<template>
  <div>
    <div style="height: 40px"></div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <!-- 基本信息 -->
      <el-tab-pane :label="$t('p0213.basicInformation')">
        <div class="tab">
          <el-form
            class="systemFont2 systemForm1"
            :model="formData"
            label-position="right"
            ref="formData"
            label-width="auto"
            hide-required-asterisk
          >
            <!-- 信息输入区 -->
            <el-row style="display: flex; justify-content: center;">
              <!-- 左侧显示列 -->
              <el-col class="baseTab-lfInfoCol">
                <!-- 头像 -->
                <el-form-item ref="imagePortrait" label-width="0px">
                  <el-col :span="3" style="margin-left: 45px">
                    <el-avatar :src="imageBase64"></el-avatar>
                  </el-col>
                  <el-col :span="1" style="margin-left: 15px">
                    <el-upload
                      action="#"
                      ref="upload"
                      :limit="1"
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="handleChange"
                      class="hdPortraitCss"
                    >
                      <!-- 上传按钮 -->
                      <el-button
                        type="text"
                        accept="image,jpeg"
                        :disabled="isdisabled"
                        v-if="show"
                        >{{ $t("p0211.upload") }}</el-button
                      >
                    </el-upload>
                  </el-col>
                </el-form-item>
                <!-- 昵称 -->
                <el-form-item :label="$t('p0211.nickName')" prop="nickName">
                  <el-col :span="21">
                    <el-input
                      v-model="formData.nickName"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      maxlength="125"
                    >
                    </el-input>
                  </el-col>
                </el-form-item>
                <!-- 生日 -->
                <el-form-item :label="$t('p0213.birthday')" prop="birthday">
                  <el-col :span="21">
                    <el-date-picker
                      v-model="formData.birthday"
                      type="date"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      maxlength="10"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
                <!-- 登录邮箱 -->
                <el-form-item
                  :label="$t('p0213.loginEmail')"
                  prop="loginEmail"
                  v-if="loginEmailshow"
                >
                  <el-col :span="21">
                    <el-input
                      v-model="formData.loginEmail"
                      size="reportContentInput"
                      :disabled="readOnly"
                    >
                    </el-input>
                  </el-col>
                </el-form-item>
                <!-- 邮箱 -->
                <el-form-item :label="$t('p0211.email')">
                  <div
                    v-for="(item, index) in formData.emailList"
                    :key="index"
                  >
                    <el-col :span="21">
                      <el-form-item
                        :prop="index < 3 ? `emailList.${index}.email` : ''"
                        :rules="
                          index < 1
                            ? checkEmail0
                            : index < 2
                            ? checkEmail1
                            : checkEmail2
                        "
                      >
                        <el-input
                          ref="email"
                          size="reportContentInput"
                          v-model="item.email"
                          class="baseTab-inputWidth"
                          style="text-align: left"
                          @blur="emailInputBlur(index)"
                          :disabled="isdisabled"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" style="padding-left: 6px;">
                      <el-form-item class="plusAndMinus" v-if="buttonShow">
                        <img
                          v-if="index == 0"
                          class="add-icon"
                          src="@/assets/add.svg"
                          @click="addInput()"
                        />
                        <img
                          v-if="index != 0"
                          class="subtract-icon"
                          src="@/assets/subtract.svg"
                          @click="deleteInput(item)"
                        />
                      </el-form-item>
                    </el-col>
                  </div>
                </el-form-item>
                <!-- 出生国家/地区 -->
                <el-form-item
                  :label="$t('p0213.birthCountryRegion')"
                  prop="birthCountryRegion"
                >
                  <el-col :span="21">
                    <el-autocomplete
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      v-model="formData.birthCountryRegion"
                      :fetch-suggestions="querySearch"
                      placeholder=""
                      @select="handleSelect"
                      clearable
                      :disabled="isdisabled"
                      value-key="codeValue"
                    ></el-autocomplete>
                  </el-col>
                </el-form-item>
                <!-- 国籍-->
                <el-form-item
                  :label="$t('p0213.nationality')"
                  prop="nationality"
                >
                  <el-col :span="21">
                    <el-autocomplete
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      v-model="formData.nationality"
                      :fetch-suggestions="querySearch"
                      placeholder=""
                      @select="handleSelect"
                      clearable
                      :disabled="isdisabled"
                      value-key="codeValue"
                    ></el-autocomplete>
                  </el-col>
                </el-form-item>
                <!-- 证件名称01 -->
                <el-form-item
                  :label="$t('p0213.documentType')"
                  prop="documentType01"
                  :rules="checkDocumentType01"
                >
                  <el-col :span="21">
                    <el-select
                      ref="documentType01"
                      class="baseTab-inputWidth"
                      v-model="formData.documentType01"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      @change="documentType01Change"
                    >
                      <el-option
                        v-for="item in documentTypeOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 证件名称02 -->
                <el-form-item
                  :label="$t('p0213.documentType')"
                  prop="documentType02"
                  :rules="checkDocumentType02"
                >
                  <el-col :span="21">
                    <el-select
                      ref="documentType02"
                      class="baseTab-inputWidth"
                      v-model="formData.documentType02"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      @change="documentType02Change"
                    >
                      <el-option
                        v-for="item in documentTypeOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <el-form-item label-width="0px">
                  <el-col :span="11">
                    <!-- 婚姻 -->
                    <el-form-item
                      :label="$t('p0213.MartialStatus')"
                      prop="maritalStatus"
                    >
                      <el-select
                        v-model="formData.maritalStatus"
                        :placeholder="$t('common.pleaseSelect')"
                        size="reportContentInput"
                        :disabled="isdisabled"
                      >
                        <el-option
                          v-for="item in martialStatusOpList"
                          :key="item.codeKey"
                          :label="item.codeValue"
                          :value="item.codeKey"
                        >
                        </el-option>
                      </el-select>
                      <el-form-item></el-form-item>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" class="baseTab-twoColGap">
                    <!-- 孩子 -->
                    <el-form-item
                      :label="$t('p0213.childrenCnt')"
                      prop="childrenCnt"
                    >
                      <el-select
                        v-model="formData.childrenCnt"
                        :placeholder="$t('common.pleaseSelect')"
                        size="reportContentInput"
                        :disabled="isdisabled"
                      >
                        <el-option
                          v-for="item in childrenList"
                          :key="item.children"
                          :label="item.children"
                          :value="item.children"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <!-- 母语 -->
                <el-form-item
                  :label="$t('p0213.motherTongue')"
                  prop="motherTongue"
                >
                  <el-col :span="21">
                    <el-select
                      v-model="formData.motherTongue"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                    >
                      <el-option
                        v-for="item in languagesOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 其他语言 -->
                <el-form-item
                  :label="$t('p0213.otherLanguages')"
                  prop="otherLanguages"
                >
                  <el-col :span="21">
                    <el-select
                      v-model="formData.otherLanguages"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                    >
                      <el-option
                        v-for="item in languagesOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 销售人员 -->
                <el-form-item :label="$t('p0213.salesUser')">
                  <el-col :span="21">
                    <el-select
                      v-model="formData.salesPerson"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      filterable
                      clearable
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                    >
                      <el-option
                        v-for="item in salesPersonList"
                        :key="item.salesPerson"
                        :label="item.name"
                        :value="item.salesPerson"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 是否为内训授权员工 -->
                <el-form-item :label="$t('p0213.isInternalTrainingAuthorized')">
                  <el-col :span="21">
                    <el-select
                      v-model="formData.isInternalTrainingAuthorized"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                    >
                      <el-option
                        :label="$t('common.yes')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('common.not')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 爱好 -->
                <el-form-item :label="$t('p0213.hobby')" prop="hobby">
                  <el-col :span="21">
                    <el-input
                      v-model="formData.hobby"
                      type="textarea"
                      size="reportLongContentInput"
                      class="baseTab-inputWidth textAreaCss"
                      :rows="3"
                      :disabled="isdisabled"
                      maxlength="240"
                    >
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <!-- 右侧显示列 -->
              <el-col class="baseTab-rtInfoCol">
                <el-form-item label-width="0px">
                  <el-col :span="11">
                    <!-- 姓 -->
                    <el-form-item
                      :label="$t('p0211.lastName')"
                      prop="lastName"
                      :rules="checkLastName"
                    >
                      <el-input
                        v-model="formData.lastName"
                        size="reportContentInput"
                        :placeholder="$t('common.required')"
                        :disabled="isdisabled"
                        maxlength="125"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" class="baseTab-twoColGap">
                    <!-- 名 -->
                    <el-form-item
                      :label="$t('p0211.firstName')"
                      prop="firstName"
                      :rules="checkFirstName"
                    >
                      <el-input
                        v-model="formData.firstName"
                        size="reportContentInput"
                        :placeholder="$t('common.required')"
                        :disabled="isdisabled"
                        maxlength="125"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <!-- 英文姓 -->
                <el-form-item label-width="0px">
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('p0211.englishLastName')"
                      prop="lastNameEn"
                      :rules="checkLastNameEn"
                    >
                      <el-input
                        v-model="formData.lastNameEn"
                        size="reportContentInput"
                        :disabled="isdisabled"
                        maxlength="125"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" class="baseTab-twoColGap">
                    <!-- 英文名 -->
                    <el-form-item
                      :label="$t('p0211.englishFirstName')"
                      prop="firstNameEn"
                      :rules="checkFirstNameEn"
                    >
                      <el-input
                        v-model="formData.firstNameEn"
                        size="reportContentInput"
                        :disabled="isdisabled"
                        maxlength="125"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <!-- 性别 -->
                <el-form-item :label="$t('p0211.sex')">
                  <el-col :span="21">
                    <el-select
                      v-model="formData.sex"
                      class="baseTab-inputWidth"
                      size="reportContentInput"
                      :placeholder="$t('p0211.sexSelection')"
                      :disabled="isdisabled"
                    >
                      <el-option
                        v-for="item in sexOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!--  登录手机-->
                <el-form-item
                  :label="$t('p0213.loginPhone')"
                  v-if="loginPhoneShow"
                >
                  <el-col :span="6">
                    <el-form-item>
                      <el-select
                        v-model="formData.loginPhoneArea"
                        size="reportContentInput"
                        :placeholder="$t('p0211.phoneArea')"
                        :disabled="readOnly"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in phoneAreaOpList"
                          :key="item.codeValue"
                          :label="item.codeValue"
                          :value="item.codeValue"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" :offset="1">
                    <el-form-item>
                      <el-input
                        ref="phone"
                        v-model="formData.loginPhone"
                        size="reportContentInput"
                        style="text-align: left"
                        @blur="phoneInputBlur(index)"
                        :disabled="readOnly"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <!--  手机-->
                <el-form-item :label="$t('p0211.telephone')">
                  <div
                    style="display: flex"
                    v-for="(telephone, index) in formData.phoneList"
                    :key="index"
                  >
                    <el-col :span="6">
                      <el-form-item>
                        <el-select
                          v-model="telephone.phoneArea"
                          size="reportContentInput"
                          :placeholder="$t('p0211.phoneArea')"
                          style="width: 100%"
                          :disabled="isdisabled"
                        >
                          <el-option
                            v-for="item in phoneAreaOpList"
                            :key="item.codeValue"
                            :label="item.codeValue"
                            :value="item.codeValue"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14" :offset="1">
                      <el-form-item
                        :prop="index < 3 ? `phoneList.${index}.phone` : ''"
                        :rules="
                          index < 1
                            ? checkPhone0
                            : index < 2
                            ? checkPhone1
                            : checkPhone2
                        "
                      >
                        <el-input
                          ref="phone"
                          v-model="telephone.phone"
                          size="reportContentInput"
                          style="text-align: left"
                          @blur="phoneInputBlur(index)"
                          :disabled="isdisabled"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3" style="padding-left: 6px;">
                      <el-form-item class="plusAndMinus" v-if="buttonShow">
                        <img
                          v-if="index == 0"
                          class="add-icon"
                          src="@/assets/add.svg"
                          @click="addInput2()"
                        />
                        <img
                          v-if="index != 0"
                          class="subtract-icon"
                          src="@/assets/subtract.svg"
                          @click="deleteInput2(telephone)"
                        />
                      </el-form-item>
                    </el-col>
                  </div>
                </el-form-item>
                <!-- 出生省 -->
                <el-form-item label-width="0px">
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('p0213.birthProvince')"
                      prop="birthProvince"
                    >
                      <el-input
                        v-model="formData.birthProvince"
                        size="reportContentInput"
                        :disabled="isdisabled"
                        maxlength="64"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" class="baseTab-twoColGap">
                    <!-- 市 -->
                    <el-form-item
                      :label="$t('p0213.birthCity')"
                      prop="birthCity"
                    >
                      <el-input
                        v-model="formData.birthCity"
                        size="reportContentInput"
                        :disabled="isdisabled"
                        maxlength="64"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <!-- 民族-->
                <el-form-item :label="$t('p0213.nation')" prop="nation">
                  <el-col :span="21">
                    <el-input
                      v-model="formData.nation"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                      maxlength="64"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!-- 证件号码01 -->
                <el-form-item
                  :label="$t('p0213.documentNo')"
                  prop="documentNo01"
                  :rules="checkDocumentNo01"
                >
                  <el-col :span="21">
                    <el-input
                      ref="documentNo01"
                      v-model="formData.documentNo01"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      @change="documentNo01Change"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <uploadFile
                      style="margin-top: 10px; line-height: normal"
                      v-if="uploadFileReloadFlag"
                      ref="UploadFileRef1"
                      :uploadFile="{
                        uploadBtnDisplayFlag: uploadBtnDisplayFlag,
                        locationCode: formData.locationCode1
                      }"
                    >
                    </uploadFile>
                  </el-col>
                </el-form-item>
                <!-- 证件号码02 -->
                <el-form-item
                  :label="$t('p0213.documentNo')"
                  prop="documentNo02"
                  :rules="checkDocumentNo02"
                >
                  <el-col :span="21">
                    <el-input
                      ref="documentNo02"
                      v-model="formData.documentNo02"
                      size="reportContentInput"
                      :disabled="isdisabled"
                      @change="documentNo02Change"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <uploadFile
                      style="margin-top: 10px; line-height: normal"
                      v-if="uploadFileReloadFlag"
                      ref="UploadFileRef2"
                      :uploadFile="{
                        uploadBtnDisplayFlag: uploadBtnDisplayFlag,
                        locationCode: formData.locationCode2
                      }"
                    >
                    </uploadFile>
                  </el-col>
                </el-form-item>
                <!-- 现住地址 -->
                <el-form-item
                  :label="$t('p0213.nowAddress')"
                  prop="nowAddress"
                >
                  <el-col :span="21">
                    <el-input
                      v-model="formData.nowAddress"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                      maxlength="360"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!-- 标签 -->
                <el-form-item :label="$t('p0213.tag')">
                  <el-col :span="21">
                    <el-select
                      v-model="formData.tagList"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      filterable
                      clearable
                      class="baseTab-inputWidth"
                      :min-rows="1"
                      multiple
                      :disabled="isdisabled"
                      @change="tagChange"
                    >
                      <el-option
                        v-for="item in tagOpList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 区域 -->
                <el-form-item
                  :label="$t('p0213.region')"
                >
                  <div v-for="(userLocation, userLocationIndex) in formData.userLocationList" :key="'regionuserLocation'+userLocation.displayOrder">
                    <el-col :span="21">
                      <RegionSelection :ref="'RegionSelectionRef'+userLocation.displayOrder" :disabled="disableFlag()" :formData="userLocation"
                                       class="baseTab-inputWidth" size="reportContentInput"/>
                    </el-col>
                    <el-col :span="3" style="padding-left: 6px;">
                      <el-form-item class="plusAndMinus" v-if="buttonShow">
                        <img
                          v-if="userLocationIndex == 0"
                          class="add-icon"
                          src="@/assets/add.svg"
                          @click="addLocation()"
                        />
                        <img
                          v-if="userLocationIndex != 0"
                          class="subtract-icon"
                          src="@/assets/subtract.svg"
                          @click="deleteLocation(userLocation)"
                        />
                      </el-form-item>
                    </el-col>
                  </div>
                </el-form-item>
                <!-- 分区 -->
                <el-form-item
                  :label="$t('p0213.subarea')"
                  prop="subarea"
                >
                  <el-col :span="21">
                    <el-input
                      v-model="formData.subarea"
                      size="reportContentInput"
                      class="baseTab-inputWidth"
                      :disabled="isdisabled"
                      maxlength="64"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!-- 所属机构 -->
                <el-form-item :label="$t('p0213.affiliation')" prop="institution" :rules="checkInstitution">
                  <el-col :span="21">
                    <el-select
                      v-model="formData.institution"
                      :placeholder="$t('common.pleaseSelect')"
                      size="reportContentInput"
                      filterable
                      clearable
                      class="baseTab-inputWidth"
                      :min-rows="1"
                      :disabled="isdisabled"
                    >
                      <el-option
                        v-for="item in institutionOptList"
                        :key="item.codeKey"
                        :label="item.codeValue"
                        :value="item.codeKey"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
                <!-- 备注 -->
                <el-form-item :label="$t('p0211.remarks')" prop="remarks">
                  <el-col :span="21">
                    <el-input
                      v-model="formData.remarks"
                      type="textarea"
                      size="reportLongContentInput"
                      class="baseTab-inputWidth textAreaCss"
                      :rows="3"
                      :disabled="isdisabled"
                      maxlength="360"
                    >
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="foot-container">
              <el-col :span="12">
                <!--编辑/保存  -->
                <el-button v-if="switchover" type="submit" @click="editor()">{{
                  $t("common.edit")
                }}</el-button>
                <el-button
                  v-if="!switchover"
                  type="submit"
                  @click.native.prevent="submitSave()"
                  >{{ $t("common.save") }}</el-button
                >
              </el-col>
              <el-col :span="12">
                <!-- 返回 -->
                <el-button type="return" @click="goBack()">{{
                  $t("common.back")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <!-- 资质 -->
      <el-tab-pane :label="$t('p0213.qualification')">
        <div class="tab">
          <el-form
            class="systemFont2 systemForm1"
            :model="qualificationFormData"
            label-position="right"
            ref="qualificationFormRef"
            label-width="100px"
            hide-required-asterisk
          >
            <!-- 个人简历 -->
            <el-row>
              <div style="margin-top:5px">
                <el-col :span="17" :offset="3">
                  <el-form-item
                    :label="$t('p0213.personalResume')"
                    prop="personalResume"
                  >
                    <div class="borderColor" style="display: flex">
                      <el-input
                        v-model="qualificationFormData.personalResume"
                        type="textarea"
                        size="reportLongContentInput"
                        :rows="4"
                        class="mar"
                        style="width: 85%;color: #000;"
                        :disabled="disabledQF"
                        maxlength="360"
                      ></el-input>
                      <uploadFile
                        style="margin-top: 15px; line-height: normal"
                        v-if="uploadQFReloadFlag"
                        ref="UploadFileRef3"
                        :uploadFile="{
                          uploadBtnDisplayFlag: uploadBtnDisplayQFFlag,
                          locationCode: qualificationFormData.locationCode3
                        }"
                      >
                      </uploadFile>
                    </div>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <!-- 第二部分 -->
            <el-row>
              <div>
                <el-row
                  v-for="(degreeItem,
                  index) in qualificationFormData.degreeList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <el-form-item label-width="0px">
                      <!-- 学历 -->
                      <el-col :span="12">
                        <el-form-item :label="$t('p0213.degree')">
                          <el-select
                            v-model="degreeItem.degree"
                            :placeholder="$t('common.pleaseSelect')"
                            size="reportContentInput"
                            style="width:100%"
                            :disabled="disabledQF"
                          >
                            <el-option
                              v-for="item in degreeOpList"
                              :key="item.codeKey"
                              :label="item.codeValue"
                              :value="item.codeKey"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          :label="$t('p0213.graduationYear')"
                          :prop="`degreeList.${index}.graduationYear`"
                        >
                          <el-date-picker
                            size="reportContentInput"
                            v-model="degreeItem.graduationYear"
                            :disabled="disabledQF"
                            type="date"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowQF">
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="graduationYearAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="graduationYearSubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" :offset="0">
                    <!-- 毕业学校 -->
                    <el-form-item
                      :label="$t('p0213.schoolOfGraduation')"
                      :prop="`degreeList.${index}.schoolOfGraduation`"
                    >
                      <el-input
                        v-model="degreeItem.schoolOfGraduation"
                        size="reportContentInput"
                        :disabled="disabledQF"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <el-row
                  v-for="(existCompanyItem,
                  index) in qualificationFormData.existingCompanyList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <!-- 关联公司/机构 -->
                    <el-form-item
                      :label="$t('p0213.AffiliatedCompany')"
                      :prop="`existingCompanyList.${index}.existingCompany`"
                    >
                      <el-input
                        v-model="existCompanyItem.existingCompany"
                        size="reportContentInput"
                        :disabled="disabledQF"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowQF">
                      <!-- <div v-for="(item, index) in existCompanyItem.existingCompanyList" :key="index" style="height: 40px"> -->
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="existingCompanyAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="existingCompanySubtract(index)"
                      />
                      <!-- </div> -->
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" :offset="0">
                    <el-form-item label-width="0px">
                      <el-col :span="12">
                        <!-- 部门 -->
                        <el-form-item
                          :label="$t('p0211.department')"
                          :prop="`existingCompanyList.${index}.department`"
                        >
                          <el-input
                            v-model="existCompanyItem.department"
                            size="reportContentInput"
                            :disabled="disabledQF"
                            maxlength="360"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <!-- 职位 -->
                        <el-form-item
                          :label="$t('p0211.position')"
                          :prop="`existingCompanyList.${index}.position`"
                        >
                          <el-input
                            v-model="existCompanyItem.position"
                            size="reportContentInput"
                            :disabled="disabledQF"
                            maxlength="360"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <el-row
                  v-for="(pastCompanyItem,
                  index) in qualificationFormData.pastCompanyList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <!-- 曾就职 -->
                    <el-form-item
                      :label="$t('p0213.servedInOffice')"
                      :prop="`pastCompanyList.${index}.pastCompany`"
                    >
                      <el-input
                        v-model="pastCompanyItem.pastCompany"
                        size="reportContentInput"
                        :disabled="disabledQF"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowQF">
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="pastCompanyAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="pastCompanySubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" :offset="0">
                    <el-form-item label-width="0px">
                      <el-col :span="12">
                        <!-- 部门 -->
                        <el-form-item
                          :label="$t('p0211.department')"
                          :prop="`pastCompanyList.${index}.pastDepartment`"
                        >
                          <el-input
                            v-model="pastCompanyItem.pastDepartment"
                            size="reportContentInput"
                            :disabled="disabledQF"
                            maxlength="360"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <!-- 职位 -->
                        <el-form-item
                          :label="$t('p0211.position')"
                          :prop="`pastCompanyList.${index}.pastPosition`"
                        >
                          <el-input
                            v-model="pastCompanyItem.pastPosition"
                            size="reportContentInput"
                            :disabled="disabledQF"
                            maxlength="360"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <el-row
                  v-for="(qualificationItem,
                  index) in qualificationFormData.qualificationList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <!-- 资质 -->
                    <el-form-item
                      :label="$t('p0213.qualification')"
                      :prop="`qualificationList.${index}.qualification`"
                    >
                      <el-input
                        v-model="qualificationItem.qualification"
                        size="reportContentInput"
                        :disabled="
                          setDisableForQualifica(
                            qualificationItem.infoVal03,
                            'input'
                          )
                        "
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="1"
                    :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item
                      label-width="0px"
                      v-if="
                        !setDisableForQualifica(
                          qualificationItem.infoVal03,
                          'btn'
                        )
                      "
                    >
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="qualificationAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="qualificationSubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" :offset="0">
                    <!-- :id="`uploadFile${index}`" -->
                    <el-form-item
                      :label="$t('p0213.qualificationAttachments')"
                      :prop="`qualificationList.${index}.locationCode4`"
                    >
                      <uploadFile
                        style="margin-top: 10px; line-height: normal"
                        ref="uploadFileRef"
                        v-if="uploadQFReloadFlag"
                        :uploadFile="{
                          uploadBtnDisplayFlag: !setDisableForQualifica(
                            qualificationItem.infoVal03,
                            'upload'
                          ),
                          locationCode: qualificationItem.locationCode4
                        }"
                      >
                      </uploadFile>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="3">
                <el-form-item
                  :label="$t('p0213.remarks')"
                  prop="supplyInfoRemarks"
                >
                  <el-input
                    style="margin-top: 9px;"
                    v-model="qualificationFormData.supplyInfoRemarks"
                    size="reportLongContentInput"
                    type="textarea"
                    :rows="4"
                    :disabled="disabledQF"
                    maxlength="360"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row class="foot-container2">
            <el-col :span="12">
              <!--编辑/保存  -->
              <el-button
                v-if="switchoverQF"
                type="submit"
                @click="qualifiedEditor()"
                >{{ $t("common.edit") }}</el-button
              >
              <el-button
                v-if="!switchoverQF"
                type="submit"
                @click.native.prevent="qualifiedSave()"
                >{{ $t("common.save") }}</el-button
              >
            </el-col>
            <el-col :span="12">
              <!-- 返回 -->
              <el-button type="return" @click="qualifiedBack()">{{
                $t("common.back")
              }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <!-- 专业技能 -->
      <el-tab-pane :label="$t('p0213.professionalSkills')">
        <div class="tab">
          <el-form
            class="systemFont2 systemForm1"
            :model="professionalSkillForm"
            label-position="right"
            ref="professionalSkillForm"
            label-width="100px"
            hide-required-asterisk
          >
            <el-row>
              <div>
                <el-row
                  v-for="(industryItem,
                  index) in professionalSkillForm.industryList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <!-- 行业经验 -->
                    <el-form-item
                      :label="$t('p0213.industryExperience')"
                      :prop="`industryList.${index}.industryExp`"
                    >
                      <el-input
                        v-model="industryItem.industryExp"
                        size="reportContentInput"
                        :placeholder="$t('p0213.pleaseEnter')"
                        :disabled="disabledPS"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="1"
                    :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowPS">
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="industryAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="industrySubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" :offset="0">
                    <el-form-item
                      :label="$t('p0213.functions')"
                      :prop="`industryList.${index}.functions`"
                    >
                      <el-input
                        v-model="industryItem.functions"
                        size="reportContentInput"
                        :placeholder="$t('p0213.pleaseEnter')"
                        :disabled="disabledPS"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <!-- 产品/技术经验 -->
                <el-row
                  v-for="(technicalItem,
                  index) in professionalSkillForm.technicalList"
                  :key="index"
                >
                  <el-col :span="8" :offset="3">
                    <!-- 行业经验 -->
                    <el-form-item
                      :label="$t('p0213.technicalExp')"
                      :prop="`technicalList.${index}.technicalExp`"
                    >
                      <el-input
                        v-model="technicalItem.technicalExp"
                        size="reportContentInput"
                        :placeholder="$t('p0213.pleaseEnter')"
                        :disabled="disabledPS"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="1"
                    :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowPS">
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="technicalAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="technicalSubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div>
                <!-- 项目经验 -->
                <el-row
                  v-for="(projectItem,
                  index) in professionalSkillForm.projectList"
                  :key="index"
                >
                  <el-col :span="17" :offset="3">
                    <el-form-item
                      :label="$t('p0213.projectExp')"
                      :prop="`projectList.${index}.projectExp`"
                    >
                      <el-input
                        v-model="projectItem.projectExp"
                        type="textarea"
                        size="reportLongContentInput"
                        :rows="4"
                        :disabled="disabledPS"
                        style="padding:7.5px 0"
                        maxlength="360"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="1"
                    :offset="0"
                    style="border: 1px solid transparent;"
                  >
                    <el-form-item label-width="0px" v-if="buttonShowPS">
                      <img
                        v-if="index == 0"
                        class="add-icon"
                        src="@/assets/add.svg"
                        @click="projectAdd()"
                      />
                      <img
                        v-if="index != 0"
                        class="subtract-icon"
                        src="@/assets/subtract.svg"
                        @click="projectSubtract(index)"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </el-form>
          <el-row class="foot-container2">
            <el-col :span="12">
              <!--编辑/保存  -->
              <el-button
                v-if="switchoverPS"
                type="submit"
                @click="skillEditor()"
                >{{ $t("common.edit") }}</el-button
              >
              <el-button
                v-if="!switchoverPS"
                type="submit"
                @click.native.prevent="skillSave()"
                >{{ $t("common.save") }}</el-button
              >
            </el-col>
            <el-col :span="12">
              <!-- 返回 -->
              <el-button type="return" @click="skillBack()">{{
                $t("common.back")
              }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <!-- 报告查询 -->
      <el-tab-pane :label="$t('p0213.reportsQuery')">
        <div class="tab">
          <p0214 ref="p0214Ref"></p0214>
        </div>
      </el-tab-pane>
      <!-- 费用结算 -->
      <el-tab-pane :label="$t('p0213.feeSettlement')">
        <div class="tab">
          <el-row style="margin-top:10px;margin-bottom:40px">
            <el-col
              :span="6"
              :offset="6"
              style="text-align:center;font-size:17px"
            >
              <span class="systemFont0">{{
                $t("p0213.topTotalCommission")
              }}</span>
              <span class="systemFont0">{{ this.topTotalCommission }}</span>
              <span class="systemFont0">{{ $t("p0213.CNY") }}</span>
            </el-col>
            <el-col :span="6" style="text-align:center;font-size:17px">
              <span class="systemFont0">{{ $t("p0213.unsettledAmount") }}</span>
              <span class="systemFont0">{{ this.unsettledAmount }}</span>
              <span class="systemFont0">{{ $t("p0213.CNY") }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table style="width:100%" :data="data">
                <!-- 上课日期时间 -->
                <el-table-column
                  :label="$t('p0213.classDateAndTime')"
                  prop="dateAndTime"
                  :formatter="dateAndTimeFormat"
                  align="center"
                  min-width="75"
                ></el-table-column>
                <!-- 课程编号 -->
                <el-table-column
                  :label="$t('p0213.courseNumber')"
                  prop="courseNumberView"
                  align="center"
                  min-width="60"
                >
                </el-table-column>
                <!-- 课程名称 -->
                <el-table-column
                  :label="$t('p0213.courseName')"
                  prop="courseName"
                  align="left"
                  min-width="100"
                ></el-table-column>
                <!-- 介绍人数 -->
                <el-table-column
                  :label="$t('p0213.introductoryNumber')"
                  prop="introduceNum"
                  align="center"
                  min-width="50"
                ></el-table-column>
                <!-- 单人佣金 -->
                <el-table-column
                  :label="$t('p0213.singleCommission')"
                  prop="singleCommission"
                  align="center"
                  min-width="50"
                ></el-table-column>
                <!-- 佣金总额 -->
                <el-table-column
                  :label="$t('p0213.totalCommission')"
                  prop="totalCommission"
                  align="center"
                  min-width="50"
                ></el-table-column>
                <!-- 货币 -->
                <el-table-column
                  :label="$t('p0213.currency')"
                  prop="currencyView"
                  align="center"
                  min-width="40"
                ></el-table-column>
                <!-- 结算状态 -->
                <el-table-column
                  :label="$t('p0213.settlementStatus')"
                  prop="settlementStatus"
                  align="center"
                  min-width="60"
                >
                  <template slot-scope="scope">
                    <!-- 已结算 -->
                    <span v-if="scope.row.commissionPayTime">{{
                      $t("p0416.settled")
                    }}</span>
                    <!-- 未结算 -->
                    <span v-if="!scope.row.commissionPayTime">{{
                      $t("p0416.noSettled")
                    }}</span>
                  </template>
                </el-table-column>
                <!-- 支付时间 -->
                <el-table-column
                  :label="$t('p0213.paymentTime')"
                  prop="commissionPayTime"
                  :formatter="dateAndTimeFormat1"
                  align="center"
                  min-width="75"
                ></el-table-column>
                <!-- 支付凭证 -->
                <el-table-column
                  :label="$t('p0213.proofOfPayment')"
                  prop="locationCode"
                  align="center"
                  min-width="75"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.locationCode"
                      @click="display(scope.row, scope.$index)"
                      type="text"
                      >{{ $t("p0213.view") }}</el-button
                    >
                    <div style="display: none;">
                      <el-image
                        :ref="'templateImgRef' + scope.$index"
                        class="img-layout"
                        :src="scope.row.paymentVoucherPath"
                        :preview-src-list="srcList[scope.$index]"
                        fit="fill"
                      >
                      </el-image>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                style="margin-top:3%"
                type="return"
                @click="feeBack()"
                >{{ $t("common.back") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <!-- 积分统计 -->
      <el-tab-pane :label="$t('p0213.pointsCou')" name="points">
        <div class="tab">
          <p0216 ref="p0216Ref"></p0216>
        </div>
      </el-tab-pane>
      <!-- 操作日志 -->
      <el-tab-pane :label="$t('p0213.oprLog')">
        <div class="tab">
          <el-row>
            <el-form
              ref="form"
              :model="oprLogForm"
              label-width="60px"
              label-position="right"
              class="systemFont1"
            >
              <el-row style="margin-top: 17px">
                <el-col :span="22" :offset="1">
                  <div style="text-align: left;" class="selectOpr">
                    <el-form-item :label="$t('p0216.selectTime')">
                      <el-select
                        v-model="oprLogForm.year"
                        @change="initSelectYear()"
                        :placeholder="$t('p0216.pleaseSelect')"
                        style="width:100px;"
                      >
                        <el-option
                          v-for="item in yearsOpList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="oprLogForm.month"
                        @change="initSelectMonth()"
                        :placeholder="$t('p0216.pleaseSelect')"
                        style="width:100px;"
                      >
                        <el-option
                          v-for="item in monthsOpList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <el-button
                        type="submit"
                        style="margin-left: 10px;"
                        @click.native.prevent="initOperation()"
                        >{{ $t("p0216.select") }}</el-button
                      >
                      <el-button
                        type="submit"
                        style="float:right;"
                        @click="openOprDialog()"
                        >{{ $t("common.export") }}</el-button
                      >
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table style="width:90%;margin:auto;" :data="logData">
                <!-- 应用 -->
                <el-table-column
                  :label="$t('p0213.oprModule')"
                  prop="operationModule"
                  align="left"
                  width="300"
                ></el-table-column>
                <!-- 操作内容 -->
                <el-table-column
                  :label="$t('p0213.oprContent')"
                  prop="operationDetail"
                  align="left"
                >
                </el-table-column>
                <!-- 操作时间 -->
                <el-table-column
                  :label="$t('p0213.oprTime')"
                  prop="operationTime"
                  :formatter="dateAndTimeFormat2"
                  align="center"
                  width="200"
                ></el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-row style="text-align: right; margin: 20px">
                <el-col :span="24">
                  <div class="block">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="logCurrentPage"
                      :page-sizes="[20, 50, 100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                </el-col>
              </el-row>
              <el-button type="return" @click="feeBack()">{{
                $t("common.back")
              }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="$t('p0213.selectExportDate')"
      :visible.sync="oprDialog"
      width="500px"
    >
      <el-form
        :model="oprLogForm"
        label-position="right"
        ref="oprLogForm"
        label-width="90px"
        class="systemFont1"
      >
        <el-form-item :label="$t('p0213.startDate')" prop="startDate">
          <el-date-picker
            v-model="oprLogForm.startDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('p0213.endDate')" prop="endDate">
          <el-date-picker
            v-model="oprLogForm.endDate"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker> </el-form-item
      ></el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOprDialog">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="exportOperationLog">{{
          $t("common.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "../../components/Common/UploadAttachment.vue";
import * as imageConversion from "image-conversion";
import { build20Id } from "../../utils/buildId.js";
import p0214 from "../CustomerInfoBase/P0214";
import p0216 from "../CustomerInfoBase/P0216";
import moment, { now } from "moment";
import RegionSelection from "./RegionSelection.vue"
export default {
  components: {
    uploadFile,
    p0214,
    p0216,
    RegionSelection,
  },
  data() {
    let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
    var validateEmailList0 = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error(this.$t("p0211.checkEmail")));
      // } else {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 0 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validateEmailList1 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 1 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validateEmailList2 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0211.correctEmail")));
        } else {
          for (let i = 0; i < this.formData.emailList.length; i++) {
            if (i != 2 && this.formData.emailList[i].email != "") {
              if (
                this.formData.emailList[i].email.toLowerCase() ==
                value.toLowerCase()
              ) {
                return callback(new Error(this.$t("p0211.replaceEmail")));
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList0 = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error(this.$t("p0211.checkPhone")));
      // } else {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 0 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[0].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList1 = (rule, value, callback) => {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 1 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[1].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    var validatePhoneList2 = (rule, value, callback) => {
      if (value) {
        let rules2 = /^[0-9]+$/;
        if (!rules2.test(value)) {
          return callback(new Error(this.$t("p0211.telephoneFormat")));
        } else {
          for (let i = 0; i < this.formData.phoneList.length; i++) {
            if (i != 2 && this.formData.phoneList[i].phone != "") {
              if (
                this.formData.phoneList[i].phoneArea ==
                this.formData.phoneList[2].phoneArea
              ) {
                if (this.formData.phoneList[i].phone == value) {
                  return callback(new Error(this.$t("p0211.replacePhone")));
                }
              }
            }
          }
        }
      }
      callback();
    };
    var validateDocumentNo01 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^[A-Za-z0-9]+$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0213.correctDocumentNo")));
        } else {
          if (this.formData.documentNo02 == value) {
            return callback(new Error(this.$t("p0213.replaceDocumentNo")));
          }
        }
      }
      callback();
    };
    var validateDocumentNo02 = (rule, value, callback) => {
      if (value) {
        let rules1 = /^[A-Za-z0-9]+$/;
        if (!rules1.test(value)) {
          return callback(new Error(this.$t("p0213.correctDocumentNo")));
        } else {
          if (this.formData.documentNo01 == value) {
            return callback(new Error(this.$t("p0213.replaceDocumentNo")));
          }
        }
      }
      callback();
    };
    var validateDocumentType01 = (rule, value, callback) => {
      if (value) {
        if (this.formData.documentType02 == value) {
          return callback(new Error(this.$t("p0213.replaceDocumentNo")));
        }
      }
      callback();
    };
    var validateDocumentType02 = (rule, value, callback) => {
      if (value) {
        if (this.formData.documentType01 == value) {
          return callback(new Error(this.$t("p0213.replaceDocumentNo")));
        }
      }
      callback();
    };
    // 验证规则 - 所属机构
    const checkInstitution = (rule, value, callback) => {
      if (!value) {
        if (this.formData.tagList !="" && this.formData.tagList !=null && this.formData.tagList.length>0) {
          if (this.formData.tagList.includes("3")) {
            callback(new Error(this.$t("p0213.affiliationEnterMsg")));
          }
        }
      }
      callback();
    };
    // 验证规则 - 姓
    const checkLastName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.formData.firstName);
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        const isChineseFirstName = /^[\u4e00-\u9fa5]+$/.test(
          this.formData.firstName
        ); // 获取姓是否为中文
        const isEnglishFirstName = /^[a-zA-Z]+$/.test(this.formData.firstName); // 获取姓是否为英文
        if (checkNotNull && isChineseFirstName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishFirstName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };

    // 验证规则 - 名
    const checkFirstName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.formData.lastName);
      const isChineseLastName = /^[\u4e00-\u9fa5]+$/.test(
        this.formData.lastName
      ); // 获取姓是否为中文
      const isEnglishLastName = /^[a-zA-Z]+$/.test(this.formData.lastName); // 获取姓是否为英文
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        // 判断语言是否一致
        if (checkNotNull && isChineseLastName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishLastName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.formData.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };
    return {
      oprDialog: false,
      p0212: p0212,
      // 当前页
      logCurrentPage: 1,
      // 每页件数
      pageSize: 20,
      total: 0,
      // 操作日志列表
      logData: [],
      // 销售人员选择列表
      salesPersonList: [],
      oprLogForm: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        startDate: "",
        endDate: ""
      },
      yearsOpList: [],
      monthsOpList: [],
      formData: {
        userID: "",
        headPortrait: "",
        nickName: "",
        birthday: "",
        loginEmail: "",
        birthCountryRegion: "",
        nationality: "",
        documentType01: "",
        documentType02: "",
        maritalStatus: "",
        childrenCnt: "",
        motherTongue: "",
        hobby: "",
        lastName: "",
        firstName: "",
        lastNameEn: "",
        firstNameEn: "",
        sex: "",
        nation: "",
        loginPhone: "",
        loginPhoneArea: "",
        documentNo01: "",
        documentNo02: "",
        nowAddress: "",
        remarks: "",
        otherLanguages: "",
        country: "",
        province: "",
        city: "",
        county: "",
        subarea: "",
        // 是否为内训授权员工
        isInternalTrainingAuthorized: "0",
        // 附件一关联代码
        locationCode1: JSON.parse(sessionStorage.getItem("p0212"))
          .locationCode1,
        // 附件二关联代码
        locationCode2: JSON.parse(sessionStorage.getItem("p0212"))
          .locationCode2,
        emailList: [
          {
            email: ""
          }
        ],
        createUser: localStorage.getItem("userId"),
        phoneList: [
          {
            phone: "",
            // 区号，默认+86
            phoneArea: ""
          }
        ],
        // 附件一
        attachment01List: [],
        // 附件二
        attachment02List: [],
        // 标签
        tagList: [],
      },
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: false,
      // 各项目显示为只读
      isdisabled: true,
      // 保存、编辑按钮切换,true：编辑；false：保存
      switchover: true,
      switchover1: false,
      // 附件
      attachment: true,
      // 登录邮箱，手机只读
      readOnly: true,
      // 上传按钮显示，true：显示;false:不显示
      show: false,
      //登录邮箱隐藏
      loginEmailshow: true,
      //登录手机号隐藏
      loginPhoneShow: true,
      // 邮箱手机号按钮隐藏
      buttonShow: true,
      // 验证邮箱判定
      validateEmailFlag: true,
      // 验证手机号判定
      validatePhoneFlag: true,
      // 验证证件名称判定
      validateDocumentType01Flag: true,
      validateDocumentType02Flag: true,
      // 头像
      imageBase64: "",
      // 国家/地区
      countryRegionOpList: [],
      // 证件名称
      documentTypeOpList: [],
      // 婚姻
      martialStatusOpList: [],
      // 孩子
      childrenList: [
        { children: 0 },
        { children: 1 },
        { children: 2 },
        { children: 3 }
      ],
      // 语言
      languagesOpList: [],
      // 区号
      phoneAreaOpList: [],
      // 性别
      sexOpList: [],
      // 标签下拉列表
      tagOpList: [],
      //地区
      chineArea: [],
      //省
      provinces: [],
      //市
      cities: [],
      // 区
      counties: [],
      areas:[],
      // 所属机构
      institutionOptList: [],
      // 老的表单
      oldformData: "",
      // 老的上传文件列表
      oldUploadFileList1: [],
      oldUploadFileList2: [],
      // 老的头像
      oldImageBase64: [],
      emailFLg: false,
      phoneFLg: false,
      currentPage: JSON.parse(sessionStorage.getItem("p0212")).currentPage,
      // 邮箱是否可删
      emailDeleteFLg: true,
      // 手机是否可删
      phoneDeleteFLg: true,
      // 上传组件加载flag
      componentsLoaded: false,
      // 旧资质表单数据
      oldQualificationFormData: {},
      // 资质表单数据
      qualificationFormData: {
        // 个人简历
        personalResume: "",
        locationCode3: "",
        // 职业信息备注
        supplyInfoRemarks: "",
        userID: JSON.parse(sessionStorage.getItem("p0212")).userID,
        createUser: localStorage.getItem("userId"),
        // 毕业学校
        // schoolOfGraduation: "",
        // 学历
        degreeList: [
          {
            degree: "",
            graduationYear: "",
            schoolOfGraduation: ""
          }
        ],
        // 关联公司/机构
        existingCompanyList: [
          {
            existingCompany: "",
            department: "",
            position: ""
          }
        ],
        // 曾就职
        pastCompanyList: [
          {
            pastCompany: "",
            pastDepartment: "",
            pastposition: ""
          }
        ],
        // 资质
        qualificationList: [
          {
            qualification: "",
            locationCode4: "",
            infoVal03: ""
          }
        ]
      },
      oldUploadFileList: {
        uploadFileListInTable: [
          {
            uploadFileList3: []
          }
        ]
      },
      // 更新后资质
      newQualificationList: [
        {
          qualification: "",
          locationCode4: "",
          infoVal03: ""
        }
      ],
      // 新的上传文件列表
      newUploadFileList: {
        uploadFileListInTable: []
      },
      // 资质旧上传文件列表
      oldUploadFileList4: [],
      oldUploadFileList5: [],
      // 学历
      degreeOpList: [],
      // 资质个项目只读
      disabledQF: true,
      // 资质添加删除按钮
      buttonShowQF: false,
      // 资质编辑保存按钮切换
      switchoverQF: true,
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadQFReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayQFFlag: false,
      // 旧的专业技能数据
      oldProfessionalSkillForm: {},
      // 专业技能
      professionalSkillForm: {
        userID: JSON.parse(sessionStorage.getItem("p0212")).userID,
        createUser: localStorage.getItem("userId"),
        // 行业经验
        industryList: [
          {
            // 行业经验
            industryExp: "",
            functions: ""
          }
        ],
        // 产品/技术经验
        technicalList: [
          {
            technicalExp: ""
          }
        ],
        // 项目经验
        projectList: [
          {
            projectExp: ""
          }
        ]
      },
      // 技术经验个项目只读
      disabledPS: true,
      // 技能添加删除按钮
      buttonShowPS: false,
      // 技能保存编辑按钮
      switchoverPS: true,
      checkInstitution: [
        { required: false, validator: checkInstitution, trigger: "" },
      ],
      checkLastName: [
        {
          required: true,
          message: this.$t("p0211.checkLastName"),
          trigger: "blur"
        },
        { required: false, validator: checkLastName, trigger: "blur" }
      ],
      checkFirstName: [
        {
          required: true,
          message: this.$t("p0211.checkFirstName"),
          trigger: "blur"
        },
        { required: false, validator: checkFirstName, trigger: "blur" }
      ],
      checkLastNameEn: [
        {
          required: false,
          message: this.$t("p0211.checkEnglishLastName"),
          trigger: "blur"
        },
        {
          pattern: /^[a-zA-Z]+$/,
          message: this.$t("p0211.checkEnglishOnly"),
          trigger: "blur"
        }
      ],
      checkFirstNameEn: [
        {
          required: false,
          message: this.$t("p0211.checkEnglishFirstName"),
          trigger: "blur"
        },
        {
          pattern: /^[a-zA-Z]+$/,
          message: this.$t("p0211.checkEnglishOnly"),
          trigger: "blur"
        }
      ],
      checkEmail0: [
        { required: true, validator: validateEmailList0, trigger: "blur" }
      ],
      checkEmail1: [
        { required: false, validator: validateEmailList1, trigger: "blur" }
      ],
      checkEmail2: [
        { required: false, validator: validateEmailList2, trigger: "blur" }
      ],
      checkPhone0: [
        { required: false, validator: validatePhoneList0, trigger: "blur" }
      ],
      checkPhone1: [
        { required: false, validator: validatePhoneList1, trigger: "blur" }
      ],
      checkPhone2: [
        { required: false, validator: validatePhoneList2, trigger: "blur" }
      ],
      checkDocumentNo01: [
        { required: false, validator: validateDocumentNo01, trigger: "blur" }
      ],
      checkDocumentNo02: [
        { required: false, validator: validateDocumentNo02, trigger: "blur" }
      ],
      checkDocumentType01: [
        {
          required: false,
          validator: validateDocumentType01,
          trigger: ["blur", "change"]
        }
      ],
      checkDocumentType02: [
        {
          required: false,
          validator: validateDocumentType02,
          trigger: ["blur", "change"]
        }
      ],
      // 费用结算一览数据
      data: [],
      unsettledAmount: 0.0,
      topTotalCommission: 0.0,
      // 证书模板预览大图Url
      srcList: [],
      activeName: ""
    };
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: this.$t("common.loading"),
      background: "rgba(255,255,255,0.8)",
      target: document.querySelector("#main-container")
    });
    await this.initData();
    await this.initExpenses();
    await this.initOperation();
    await this.getSalesPersonList();
    for (let index = 0; index < this.formData.userLocationList.length; index++) {
      const userLocation = this.formData.userLocationList[index]
      await this.$refs[`RegionSelectionRef${userLocation.displayOrder}`][0].getChineArea()
      await this.$refs[`RegionSelectionRef${userLocation.displayOrder}`][0].$refs.formDataRef.clearValidate(['country', 'province', 'city', 'area'])
    }
    loading.close()
  },
  methods: {
    checkNotNull(str) {
      if (str === null || str === "" || typeof str === "undefined") {
        return false;
      } else {
        return true;
      }
    },
    disableFlag() {
      return this.isdisabled;
    },
    // 关闭导出弹框
    closeOprDialog() {
      this.oprDialog = false;
    },
    // 打开导出弹框
    openOprDialog() {
      this.oprLogForm.startDate = "";
      this.oprLogForm.endDate = "";
      this.oprDialog = true;
    },
    // 获取首月
    getMonthFrist(timestamp) {
      let date = timestamp ? new Date(timestamp) : new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return new Date(year, month, 1);
    },
    // 获取末月
    getMonthLast(timestamp) {
      let date = timestamp ? new Date(timestamp) : new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      // day为0表示获取上一个月最后一天，所以month+1
      // 86300表示一天秒数，最后日期为 23:59:59
      let lastDay = new Date(year, month + 1, 0);
      lastDay.setHours(23, 59, 59);
      return lastDay;
    },
    // 年份下拉框
    initSelectYear(year) {
      this.years = [];
      var myDate = new Date();
      var startYear = myDate.getFullYear() - 50; // 起始年份
      var endYear = myDate.getFullYear() + 50; // 结束年份

      this.yearsOpList = [];
      for (var i = startYear; i <= endYear; i++) {
        this.yearsOpList.push({ value: i, label: i });
      }
      // for(let i=0;i<30;i++){
      // this.years.push({value:(year - i),label:(year - i)+ "年"});
      // }
    },
    // 月份下拉框initDates
    initSelectMonth() {
      this.monthsOpList = [];
      for (let i = 1; i <= 12; i++) {
        this.monthsOpList.push({ value: i, label: i + "月" });
      }
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.logCurrentPage = 1;
      this.initOperation();
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.logCurrentPage = val;
      this.initOperation();
    },
    // 获取销售人员列表
    getSalesPersonList() {
      let url = "/api/basicInformation/getSalesPersonList";
      this.$http
        .post(url, {
          salesPerson: this.p0212.userID,
          language: "zh"
        })
        .then(response => {
          if (response.data.code === 200) {
            this.salesPersonList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取操作日志信息
    initOperation() {
      this.initSelectYear(this.oprLogForm.year);
      this.initSelectMonth();
      var date = new Date(this.oprLogForm.year, this.oprLogForm.month - 1, 1);
      var startTime = this.getMonthFrist(date);
      var endTime = this.getMonthLast(date);
      // console.log("🚀 ~ file: P0213.vue:2346 ~ initOperation ~ endTime:", endTime)
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/initOperation";
      this.$http
        .post(url, {
          userID: this.p0212.userID,
          language: "zh",
          currentSize: (this.logCurrentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
          startTime: startTime,
          endTime: endTime
        })
        .then(response => {
          if (response.data.code === 200) {
            this.logData = response.data.data.operationLogList;
            this.total = response.data.data.total;
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 导出操作日志
    exportOperationLog() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/exportOperation";
      this.$http
        .post(
          url,
          {
            userID: this.p0212.userID,
            language: "zh",
            startTime: this.oprLogForm.startDate,
            endTime: this.oprLogForm.endDate
          },
          { responseType: "blob" }
        )
        .then(response => {
          // console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          // console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message({
              message: this.$t("p0213.checkLog"),
              type: "warning"
            });
            loading.close();
          } else {
            const fileName =
              this.$t("common.user") +
              this.$t("p0213.oprLog") +
              "-" +
              this.formData.lastName +
              this.formData.firstName +
              this.$t("p0212.couponFileFormat");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              // console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            this.oprDialog = false;
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0212.errorCoupon"));
          loading.close();
        });
    },

    // 绿夹克证书资质活性剔除
    setDisableForQualifica(val03, ckFlg) {
      if (val03 === null || val03 === "") {
        if (ckFlg === "input") {
          return this.disabledQF;
        } else if (ckFlg === "btn") {
          return !this.buttonShowQF;
        } else {
          return !this.uploadBtnDisplayQFFlag;
        }
      } else {
        return true;
      }
    },
    // 获取locationCode数据
    initCodeData() {
      let url = "/api/basicInformation/initCodeData";
      let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
      this.$http
        .post(
          url,
          qs.stringify({
            userID: p0212.userID,
            sysLanguage: "zh" // 当前选择的语言，当前只设定中文
          })
        )
        .then(response => {
          if (response.data.code === 200) {
            this.qualificationFormData.locationCode3 =
              response.data.data.locationCode3;
            this.qualificationFormData.qualificationList =
              response.data.data.qualificationList;
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 初始化数据
    async initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/initDetail";
      let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
      await this.$http
        .post(
          url,
          qs.stringify({
            userID: p0212.userID,
            sysLanguage: "zh" // 当前选择的语言，当前只设定中文
          })
        )
        .then(response => {
          // console.log("response:" + JSON.stringify(response.data.data));
          this.formData = response.data.data;
          if (response.data.data.headPortrait == null) {
            this.imageBase64 = require("../../assets/headPortrait.png");
          } else {
            this.imageBase64 =
              "data:image/png;base64," + response.data.data.headPortrait;
          }
          if (
            (response.data.data.loginEmail == null ||
              response.data.data.loginEmail == "") &&
            (response.data.data.loginPhone == null ||
              response.data.data.loginPhone == "")
          ) {
            this.loginEmailshow = false;
            this.loginPhoneShow = false;
          }
          // if (
          //   response.data.data.loginPhone == null ||
          //   response.data.data.loginPhone == ""
          // ) {
          //   this.loginPhoneShow = false;
          // }
          // 手机为空
          if (response.data.data.phoneList.length == 0) {
            this.formData.phoneList.push({
              phoneArea: response.data.data.phoneAreaOpList[0].codeValue,
              phone: ""
            });
          }
          // 邮箱为空
          if (response.data.data.emailList.length == 0) {
            this.formData.emailList.push({
              email: ""
            });
          }
          // 性别下拉框数据
          this.sexOpList = response.data.data.sexOpList;
          // this.formData.sex = response.data.data.sexOpList[0].codeKey;
          // 区号下拉框数据
          this.phoneAreaOpList = response.data.data.phoneAreaOpList;
          // 默认区号+86
          if (
            response.data.data.loginPhoneArea == null ||
            response.data.data.loginPhoneArea == ""
          ) {
            this.formData.loginPhoneArea =
              response.data.data.phoneAreaOpList[0].codeValue;
          }
          if (
            response.data.data.phoneList.phoneArea == null ||
            response.data.data.phoneList.phoneArea == ""
          ) {
            this.formData.phoneList[0].phoneArea =
              response.data.data.phoneAreaOpList[0].codeValue;
          }
          // 证件名称下拉数据
          this.documentTypeOpList = response.data.data.documentTypeOpList;
          // this.formData.documentType01 = response.data.data.documentTypeOpList[0].codeValue;
          // this.formData.documentType02 = response.data.data.documentTypeOpList[1].codeValue;
          // 语言下拉数据
          this.languagesOpList = response.data.data.languagesOpList;
          // 默认中文
          // if (
          //   response.data.data.motherTongue == null ||
          //   response.data.data.motherTongue == ""
          // ) {
          //   this.formData.motherTongue =
          //     response.data.data.languagesOpList[0].codeKey;
          // }
          // 婚姻下拉数据
          this.martialStatusOpList = response.data.data.martialStatusOpList;
          // 国家/地区下拉数据
          this.countryRegionOpList = response.data.data.countryRegionOpList;
          // 标签下拉数据
          this.tagOpList = response.data.data.tagOpList
          this.institutionOptList = response.data.data.institutionOptList
          // 标签列表
          this.formData.tagList = response.data.data.tagList
          // 默认中国
          // if (
          //   response.data.data.birthCountryRegion == null ||
          //   response.data.data.birthCountryRegion == ""
          // ) {
          //   this.formData.birthCountryRegion =
          //     response.data.data.countryRegionOpList[0].codeValue;
          // }
          // if (
          //   response.data.data.nationality == null ||
          //   response.data.data.nationality == ""
          // ) {
          //   this.formData.nationality =
          //     response.data.data.countryRegionOpList[0].codeValue;
          // }

          // 按钮隐藏
          this.buttonShow = false;
          // 简历数据
          this.qualificationFormData.personalResume =
            response.data.data.personalResume;
          this.qualificationFormData.supplyInfoRemarks =
            response.data.data.supplyInfoRemarks;
          this.qualificationFormData.locationCode3 =
            response.data.data.locationCode3;
          // 学历下拉框
          this.degreeOpList = response.data.data.degreeOpList;
          // 学历信息
          if (response.data.data.degreeList.length == 0) {
          } else {
            this.qualificationFormData.degreeList =
              response.data.data.degreeList;
          }
          // 关联公司/机构
          if (response.data.data.existingCompanyList.length == 0) {
          } else {
            this.qualificationFormData.existingCompanyList =
              response.data.data.existingCompanyList;
          }
          // 曾就职公司/机构
          if (response.data.data.pastCompanyList.length == 0) {
          } else {
            this.qualificationFormData.pastCompanyList =
              response.data.data.pastCompanyList;
          }
          // 资质
          if (response.data.data.qualificationList.length == 0) {
          } else {
            this.qualificationFormData.qualificationList =
              response.data.data.qualificationList;
            this.newQualificationList = response.data.data.qualificationList;
          }
          // 专业技能数据
          // 行业经验
          if (response.data.data.industryList.length == 0) {
          } else {
            this.professionalSkillForm.industryList =
              response.data.data.industryList;
          }

          // 产品/技术经验
          if (response.data.data.technicalList.length == 0) {
          } else {
            this.professionalSkillForm.technicalList =
              response.data.data.technicalList;
          }
          // 项目经验
          if (response.data.data.projectList.length == 0) {
          } else {
            this.professionalSkillForm.projectList =
              response.data.data.projectList;
          }
          // 旧技能信息
          this.oldProfessionalSkillForm = JSON.stringify(
            this.professionalSkillForm
          );
          this.formData.oldIsTrainTeacher = JSON.parse(
            JSON.stringify(this.formData.isTrainTeacher)
          );
          // 初始化内训授权员工字段的旧值
          this.formData.oldIsInternalTrainingAuthorized = JSON.parse(
            JSON.stringify(this.formData.isInternalTrainingAuthorized)
          );
          this.reloadUploadQF();
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0213.userInformationFailed"));
        });
    },
    // 添加邮箱
    addInput() {
      if (this.formData.emailList.length < 3) {
        this.formData.emailList.push({
          email: ""
        });
      } else {
        this.$message({
          message: this.$t("p0211.maxEmail"),
          type: "warning"
        });
      }
    },
    // 删除邮箱
    deleteInput(inputIndex) {
      if (this.formData.emailList.length === 1) {
        this.formData.emailList = [
          {
            email: ""
          }
        ];
        return this.formData.emailList;
      }
      let index = this.formData.emailList.indexOf(inputIndex);

      if (index != -1) {
        this.formData.emailList.splice(index, 1);
      }
    },
    // 邮箱光标移出
    emailInputBlur(index) {
      if (this.validateEmailFlag) {
        for (let i = 0; i < this.$refs["email"].length; i++) {
          if (index != i) {
            this.validateEmailFlag = false;
            this.$refs["email"][i].focus();
            this.$refs["email"][i].blur();
          }
          if (i == this.$refs["email"].length - 1) {
            this.validateEmailFlag = true;
          }
        }
      }
    },
    // 添加手机号
    addInput2() {
      if (this.formData.phoneList.length < 3) {
        this.formData.phoneList.push({
          phoneArea: this.phoneAreaOpList[0].codeValue,
          phone: ""
        });
      } else {
        this.$message({
          message: this.$t("p0211.maxPhone"),
          type: "warning"
        });
      }
    },
    // 删除手机号
    deleteInput2(inputIndex) {
      if (this.formData.phoneList.length === 1) {
        this.formData.phoneList = [
          {
            phoneArea: this.phoneAreaOpList[0].codeValue,
            phone: ""
          }
        ];
        return this.formData.phoneList;
      }
      let index = this.formData.phoneList.indexOf(inputIndex);

      if (index != -1) {
        this.formData.phoneList.splice(index, 1);
      }
    },
      // 添加地区
      addLocation() {
        const lastItem = this.formData.userLocationList[this.formData.userLocationList.length - 1];
        this.formData.userLocationList.push({
          userLocationId: null,
          userId: JSON.parse(sessionStorage.getItem("p0212")).userID,
          country: '',
          province: '',
          city: null,
          area: null,
          displayOrder:lastItem.displayOrder + 1
        });
      },
     // 删除地区
      deleteLocation(userLocation) {
        if (this.formData.userLocationList.length === 1) {
          // 如果只剩最后一个，重置它而不是删除
          this.formData.userLocationList[0] = {
            userLocationId: null,
            userId: JSON.parse(sessionStorage.getItem("p0212")).userID,
            country: '',
            province: '',
            city: null,
            area: null,
            displayOrder:1
          };
          return;
        }
        const index = this.formData.userLocationList.indexOf(userLocation);
        if (index !== -1) {
          this.formData.userLocationList.splice(index, 1);
        }
      },
    // 手机号光标移出
    phoneInputBlur(index) {
      if (this.validatePhoneFlag) {
        for (let i = 0; i < this.$refs["phone"].length; i++) {
          if (index != i) {
            this.validatePhoneFlag = false;
            this.$refs["phone"][i].focus();
            this.$refs["phone"][i].blur();
          }
          if (i == this.$refs["phone"].length - 1) {
            this.validatePhoneFlag = true;
          }
        }
      }
    },
    // 证件类型改变
    documentType01Change() {
      this.$refs.formData.validateField("documentType02");
    },
    // 证件类型改变
    documentType02Change() {
      this.$refs.formData.validateField("documentType01");
    },
    // 证件号码改变
    documentNo01Change() {
      this.$refs.formData.validateField("documentNo02");
    },
    // 证件号码改变
    documentNo02Change() {
      this.$refs.formData.validateField("documentNo01");
    },
    // 编辑按钮
    editor() {
      this.switchover = false;
      this.isdisabled = false;
      this.buttonShow = true;
      this.show = true;
      this.isOldData();
      // 上传按钮显示
      this.changeUploadFileStatus();
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },
    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    // 获取旧的数据
    isOldData() {
      this.oldformData = JSON.stringify(this.formData);
      this.oldImageBase64 = this.imageBase64;
      this.$refs.UploadFileRef1.getUploadFileList().forEach(element => {
        this.oldUploadFileList1.push(element.name);
      });
      this.$refs.UploadFileRef2.getUploadFileList().forEach(element => {
        this.oldUploadFileList2.push(element.name);
      });
    },
    // 内容变更判断
    isContentChanged() {
      let uploadFileList1 = [];
      this.$refs.UploadFileRef1.getUploadFileList().forEach(element => {
        uploadFileList1.push(element.name);
      });
      let uploadFileList2 = [];
      this.$refs.UploadFileRef2.getUploadFileList().forEach(element => {
        uploadFileList2.push(element.name);
      });
      if (
        this.oldImageBase64 === this.imageBase64 &&
        this.oldformData === JSON.stringify(this.formData) &&
        JSON.stringify(this.oldUploadFileList1) ===
          JSON.stringify(uploadFileList1) &&
        JSON.stringify(this.oldUploadFileList2) ===
          JSON.stringify(uploadFileList2)
      ) {
        this.$message({
          message: this.$t("p0213.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 登录邮箱，手机号不可以删
    loginDeleted() {
      if (
        (this.formData.loginEmail == "" || this.formData.loginEmail == null) &&
        (this.formData.loginPhone == "" || this.formData.loginPhone == null)
      ) {
        return false;
      } else if (
        this.formData.loginEmail != null &&
        this.formData.loginEmail != "" &&
        (this.formData.loginPhone == "" || this.formData.loginPhone == null)
      ) {
        for (let i = 0; i < this.formData.emailList.length; i++) {
          if (this.formData.emailList[i].email == this.formData.loginEmail) {
            this.emailDeleteFLg = false;
            continue;
          }
        }
        if (this.emailDeleteFLg) {
          return true;
        } else {
          return false;
        }
      } else if (
        (this.formData.loginEmail == "" || this.formData.loginEmail == null) &&
        this.formData.loginPhone != null &&
        this.formData.loginPhone != ""
      ) {
        for (let i = 0; i < this.formData.phoneList.length; i++) {
          if (this.formData.phoneList[i].phone == this.formData.loginPhone) {
            this.phoneDeleteFLg = false;
            continue;
          }
        }
        if (this.phoneDeleteFLg) {
          return true;
        } else {
          return false;
        }
      } else {
        for (let i = 0; i < this.formData.emailList.length; i++) {
          if (this.formData.emailList[i].email == this.formData.loginEmail) {
            this.emailDeleteFLg = false;
            continue;
          }
        }
        for (let i = 0; i < this.formData.phoneList.length; i++) {
          if (this.formData.phoneList[i].phone == this.formData.loginPhone) {
            this.phoneDeleteFLg = false;
            continue;
          }
        }
        if (!this.emailDeleteFLg && !this.phoneDeleteFLg) {
          return false;
        } else {
          return true;
        }
      }
    },
    // 标签变更时处理
    tagChange() {
      this.$refs.formData.validateField(['institution'])
    },
    // 保存按钮
    submitSave() {
      for (let index = 0; index < this.formData.userLocationList.length; index++) {
        const userLocation = this.formData.userLocationList[index]
        this.$refs[`RegionSelectionRef${userLocation.displayOrder}`][0].$refs.formDataRef.clearValidate(['country','province', 'city', 'area']);
      }
      if (this.isContentChanged()) {
        return;
      }
      if (this.loginDeleted()) {
        this.$message({
          message: this.$t("p0213.emailPhoneNotDelet"),
          type: "warning"
        });

        this.phoneDeleteFLg = true;
        this.emailDeleteFLg = true;
        return;
      }
      // 标签选择，必须填写区域
      let regionFlag = false
      if (this.formData.tagList !="" && this.formData.tagList !=null && this.formData.tagList.length>0) {
        // 检查区域是否输入
        for (let index = 0; index < this.formData.userLocationList.length; index++) {
          const userLocation = this.formData.userLocationList[index]
          this.$refs[`RegionSelectionRef${userLocation.displayOrder}`][0].$refs.formDataRef.validateField(['country', 'province', 'city', 'area'], valid => {
            if (valid) {
              regionFlag = true;
            }
          })
        }
        // TODO
        this.$refs.formData.validateField(['institution'], valid => {
          if (valid) {
            regionFlag = true;
          }
        })
        // 判断销售人员，培训师
        // this.formData.isSalesPerson = "0"
        // this.formData.isTrainTeacher = "0"
        // this.formData.tagList.forEach(item =>{
        //   if (item == "0") {
        //     this.formData.isSalesPerson = "1"
        //   }
        //   if (item == "1") {
        //     this.formData.isTrainTeacher = "1"
        //   }
        // })
      } else {
        if (this.formData.userLocationList && this.formData.userLocationList.length > 1 ||
          (this.formData.userLocationList.length === 1 && this.formData.userLocationList[0].country && this.formData.userLocationList[0].country !== '')) {
          for (let index = 0; index < this.formData.userLocationList.length; index++) {
            const userLocation = this.formData.userLocationList[index]
            this.$refs[`RegionSelectionRef${userLocation.displayOrder}`][0].$refs.formDataRef.validateField(['country', 'province', 'city', 'area'], valid => {
              if (valid) {
                regionFlag = true;
              }
            })
          }
        }
      }
      // 判断区域是否是否重复
      for (let i = 0; i < this.formData.userLocationList.length; i++) {
        for (let j = i + 1; j < this.formData.userLocationList.length; j++) {
          const item1 = this.formData.userLocationList[i];
          const item2 = this.formData.userLocationList[j];

          if (
            item1.country === item2.country &&
            item1.province === item2.province &&
            item1.city === item2.city &&
            item1.area === item2.area
          ) {
            // Found duplicate items
            regionFlag = true;
            this.$message.warning('区域存在重复');
            break;
          }
        }
      }
      console.log(regionFlag)
      if(regionFlag){
        return;
      }
      for (let i = 0; i < this.formData.emailList.length; i++) {
        if (
          this.formData.emailList[i].email != null &&
          this.formData.emailList[i].email != ""
        ) {
          this.emailFLg = true;
          continue;
        }
      }
      for (let i = 0; i < this.formData.phoneList.length; i++) {
        if (
          this.formData.phoneList[i].phone != "" &&
          this.formData.phoneList[i].phone != null
        ) {
          this.phoneFLg = true;
          continue;
        }
      }
      if (this.emailFLg || this.phoneFLg) {
        this.$refs["formData"].validate(valid => {
          // 检查邮箱和手机号，必须有一个输入
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: this.$t("common.loading"),
              background: "rgba(255,255,255,0.8)",
              target: document.querySelector("#main-container")
            });
            // 附件提交

            let imgfile = new FormData();
            let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
            this.formData.userID = p0212.userID;
            this.formData.createUser = localStorage.userId;
            imgfile.append("multipartFiles", this.formData.headPortrait);
            imgfile.append("material", JSON.stringify(this.formData));
            let url = "/api/basicInformation/submitSave";
            this.$http
              .post(url, imgfile)
              .then(response => {
                if (response.data.code === 200) {
                  this.$message.success(
                    this.$t("p0213.saveInformationSuccess")
                  );
                  this.phoneDeleteFLg = true;
                  this.emailDeleteFLg = true;
                  this.upload();
                  this.initData();
                  this.getSalesPersonList();
                } else {
                  this.$message.error(response.data.message);
                }
                loading.close();
                this.phoneDeleteFLg = true;
                this.emailDeleteFLg = true;
              })
              .catch(err => {
                this.phoneDeleteFLg = true;
                this.emailDeleteFLg = true;
                loading.close();
                console.log(err);
                this.$message.error(this.$t("p0213.saveInformationFailed"));
              });
          }
        });
      } else {
        this.phoneDeleteFLg = true;
        this.emailDeleteFLg = true;
        this.$message({
          message: this.$t("p0211.mustInput"),
          type: "warning"
        });
      }
    },
    // 附件提交
    async upload() {
      await this.$refs.UploadFileRef1.submitUploadFile();
      await this.$refs.UploadFileRef2.submitUploadFile();
      // 切换编辑按钮
      this.switchover = true;
      this.isdisabled = true;
      this.buttonShow = false;
      this.show = false;
      this.oldUploadFileList1 = [];
      this.oldUploadFileList2 = [];
      this.phoneFLg = false;
      this.emailFLg = false;
      this.changeUploadFileStatus();
    },
    // 头像
    handleChange(file, fileList) {
      this.$refs.upload.clearFiles();
      if (this.beforeAvatarUpload(file.raw)) {
        // this.formData.headPortrait = file.raw;
        this.imageBase64 = URL.createObjectURL(file.raw);
      }
    },
    beforeAvatarUpload(file) {
      // console.log(file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      // console.log(isJPG);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error(this.$t("p0211.imageFormat"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("p0211.imageSize"));
      }
      // 压缩
      if (isJPG && isLt2M) {
        imageConversion.compressAccurately(file, 1).then(res => {
          // console.log(res)
          this.formData.headPortrait = new window.File([res], file.name, {
            type: file.type
          }); // 将blob类型转为file
          // console.log("文件",this.formData.headPortrait)
        });
      }
      return isJPG && isLt2M;
    },
    querySearch(queryString, cb) {
      var countryRegionOpList = this.countryRegionOpList;
      // console.log("countryRegionOpList" + JSON.stringify(countryRegionOpList));
      cb(countryRegionOpList);
    },
    handleSelect(item) {
      // console.log(item);
    },
    // 返回按钮
    goBack() {
      //返回按钮标示
      sessionStorage.setItem("detail", true);
      sessionStorage.setItem("currentPage", this.currentPage);
      // this.$router.push({ path: "/views/CustomerInfoBase/P0212" });
      this.$router.go(-1);
    },

    // 资质

    // 学历/毕业年份增加
    graduationYearAdd(index) {
      this.qualificationFormData.degreeList.push({
        degree: "",
        graduationYear: "",
        schoolOfGraduation: ""
      });
    },
    // 学历/毕业年份删减
    graduationYearSubtract(index) {
      this.qualificationFormData.degreeList.splice(index, 1);
    },
    // 关联公司/机构增加
    existingCompanyAdd() {
      this.qualificationFormData.existingCompanyList.push({
        existingCompany: "",
        department: "",
        position: ""
      });
    },
    // 关联公司/机构删减
    existingCompanySubtract(index) {
      this.qualificationFormData.existingCompanyList.splice(index, 1);
    },
    // 曾就职增加
    pastCompanyAdd() {
      this.qualificationFormData.pastCompanyList.push({
        pastCompany: "",
        pastDepartment: "",
        pastposition: ""
      });
    },
    // 曾就职删减
    pastCompanySubtract(index) {
      this.qualificationFormData.pastCompanyList.splice(index, 1);
    },
    // 资质添加
    qualificationAdd() {
      this.qualificationFormData.qualificationList.push({
        qualification: "",
        locationCode4: build20Id(),
        infoVal03: ""
      });
    },
    // 资质删除
    qualificationSubtract(index) {
      this.qualificationFormData.qualificationList.splice(index, 1);
      this.reloadUploadQF();
    },
    // 资质 编辑按钮
    qualifiedEditor() {
      this.buttonShowQF = true;
      this.disabledQF = false;
      this.switchoverQF = false;
      this.isOldDataQS();
      // 上传按钮显示
      this.changeUploadQFStatus();
    },
    // 改变上传文件的状态
    changeUploadQFStatus() {
      this.uploadBtnDisplayQFFlag = !this.uploadBtnDisplayQFFlag;
      this.reloadUploadQF();
    },
    // 重新加载上传附件控件
    async reloadUploadQF() {
      this.uploadQFReloadFlag = false;
      await this.$nextTick();
      this.uploadQFReloadFlag = true;
    },
    // 获取旧的数据
    isOldDataQS() {
      this.oldQualificationFormData = JSON.stringify(
        this.qualificationFormData
      );
      this.$refs.UploadFileRef3.getUploadFileList().forEach(element => {
        this.oldUploadFileList4.push(element.name);
      });
      for (
        let i = 0;
        i < this.qualificationFormData.qualificationList.length;
        i++
      ) {
        this.$refs.uploadFileRef[i].getUploadFileList().forEach(element => {
          this.oldUploadFileList5.push(element.name);
        });
      }
    },
    // 资质内容变更判断
    contentChangQS() {
      let uploadFileList4 = [];
      this.$refs.UploadFileRef3.getUploadFileList().forEach(element => {
        uploadFileList4.push(element.name);
      });
      let uploadFileList5 = [];
      for (
        let i = 0;
        i < this.qualificationFormData.qualificationList.length;
        i++
      ) {
        this.$refs.uploadFileRef[i].getUploadFileList().forEach(element => {
          uploadFileList5.push(element.name);
        });
      }
      if (
        this.oldQualificationFormData ===
          JSON.stringify(this.qualificationFormData) &&
        JSON.stringify(this.oldUploadFileList4) ===
          JSON.stringify(uploadFileList4) &&
        JSON.stringify(this.oldUploadFileList5) ===
          JSON.stringify(uploadFileList5)
      ) {
        this.$message({
          message: this.$t("p0213.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 资质 保存按钮
    qualifiedSave() {
      if (this.contentChangQS()) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/qualifiedSave";
      this.$http
        .post(url, this.qualificationFormData)
        .then(response => {
          if (response.data.code === 200) {
            this.$message.success(this.$t("p0213.savedSuccessfullyQS"));
            this.uploadQF();
          } else {
            this.$message.error(this.$t("p0213.saveFailedQS"));
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    async uploadQF() {
      this.initCodeData();
      await this.$refs.UploadFileRef3.submitUploadFile();
      for (let i = 0; i < this.newQualificationList.length; i++) {
        if (
          this.newQualificationList[i].infoVal03 == null ||
          this.newQualificationList[i].infoVal03 == ""
        ) {
          // console.log(i);
          await this.$refs.uploadFileRef[i].submitUploadFile();
        }
      }
      this.newQualificationList = [];
      this.initData();
      // 切换编辑按钮
      this.buttonShowQF = false;
      this.disabledQF = true;
      this.switchoverQF = true;
      this.oldUploadFileList4 = [];
      this.oldUploadFileList5 = [];
      this.changeUploadQFStatus();
    },
    // 资质 返回按钮
    qualifiedBack() {
      this.goBack();
    },

    // 行业技能

    // 行业经验添加
    industryAdd() {
      this.professionalSkillForm.industryList.push({
        industryExp: "",
        functions: ""
      });
    },
    // 行业经验删除
    industrySubtract(index) {
      this.professionalSkillForm.industryList.splice(index, 1);
    },
    // 技术经验添加
    technicalAdd() {
      this.professionalSkillForm.technicalList.push({
        technicalExp: ""
      });
    },
    // 技术经验删除
    technicalSubtract(index) {
      this.professionalSkillForm.technicalList.splice(index, 1);
    },
    // 项目经验添加
    projectAdd() {
      this.professionalSkillForm.projectList.push({
        projectExp: ""
      });
    },
    // 项目经验添加
    projectSubtract(index) {
      this.professionalSkillForm.projectList.splice(index, 1);
    },
    // 技能编辑
    skillEditor() {
      this.disabledPS = false;
      this.buttonShowPS = true;
      this.switchoverPS = false;
    },
    // 技能数据变更判断
    // 比较数据是否发生变更
    isSkillChanged() {
      if (
        this.oldProfessionalSkillForm ===
        JSON.stringify(this.professionalSkillForm)
      ) {
        this.$message({
          message: this.$t("common.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 技能保存
    skillSave() {
      if (this.isSkillChanged()) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/skillSave";
      this.$http
        .post(url, this.professionalSkillForm)
        .then(response => {
          if (response.data.code === 200) {
            this.$message.success(this.$t("p0213.savedSuccessfullyPS"));
            this.disabledPS = true;
            this.buttonShowPS = false;
            this.switchoverPS = true;
            this.initData();
          } else {
            this.$message.error(this.$t("p0213.saveFailedPS"));
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 技能返回
    skillBack() {
      this.goBack();
    },
    // 费用结算初始化
    initExpenses() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/searchPersonalCommission";
      this.$http
        .post(url, { userId: this.p0212.userID })
        .then(response => {
          if (response.data.code === 200) {
            this.data = response.data.data;
            //  console.log("response.data.data",JSON.stringify(response.data.data))s
            if (response.data.data != null && response.data.data != "") {
              this.unsettledAmount = response.data.data[0].unsettledAmount.toFixed(
                2
              );
              this.topTotalCommission = response.data.data[0].topTotalCommission.toFixed(
                2
              );
            } else {
              this.unsettledAmount = "0.00";
              this.topTotalCommission = "0.00";
            }
            loading.close();
            // 支付凭证预览大图Url
            if (response.data.data != null) {
              this.data.forEach(element => {
                this.srcList.push([element.paymentVoucherPath]);
              });
            }
            // console.log("this.srcList", this.srcList);
            this.pageLoading = false;
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 时间标准化
    dateAndTimeFormat(row) {
      if (row.dateAndTime != null && row.dateAndTime != "") {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    dateAndTimeFormat1(row) {
      if (row.commissionPayTime != null && row.commissionPayTime != "") {
        return moment(row.commissionPayTime).format("YYYY-MM-DD HH:mm");
      }
    },
    dateAndTimeFormat2(row) {
      if (row.operationTime != null && row.operationTime != "") {
        return moment(row.operationTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 预览支付凭证
    display(row, index) {
      this.$refs["templateImgRef" + index].clickHandler();
    },
    // 积分统计页面初始化
    handleClick(tab, event) {
      if (this.activeName == "points") {
        let formName = "p0216Ref";
        let ref = this.$refs[formName];
        if (Array.isArray(ref)) {
          ref = ref[0];
        }
        ref.init();
      }
    },
    // 费用结算返回
    feeBack() {
      this.goBack();
    },
    // 培训师两种0，2取消，为验证未修改 保持数据一致
    isTrainTeacherChange() {
      // 取消时
      if (this.formData.isTrainTeacher == "0") {
        const oldIsTrainTeacher = this.formData.oldIsTrainTeacher;
        // 如果初始化没有被选中
        if (oldIsTrainTeacher !== "1") {
          this.formData.isTrainTeacher = oldIsTrainTeacher;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 基本信息 - 左侧输入列
.baseTab-lfInfoCol {
  width: 600px;
}
// 基本信息 - 右侧录入列
.baseTab-rtInfoCol {
  width: 600px;
}
// 基本信息 - 输入框
.baseTab-inputWidth {
  width: 100% !important;
}
// 基本信息 - 一行双输入框时，框间间隔
.baseTab-twoColGap {
  margin-left: -2%;
}

@media screen and (max-width: 1366px) {
  // 基本信息 - 左侧输入列
  .baseTab-lfInfoCol {
    width: 500px;
  }
  // 基本信息 - 右侧录入列
  .baseTab-rtInfoCol {
    width: 500px;
  }
}



.tab {
  border: 1px solid rgb(204, 204, 204);
  border-top: none;
  padding: 15px;
  margin-bottom: 15px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-top: none;
  border-right: none;
  border-left: none;
  border-radius: 0;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  border-color: rgb(0, 0, 0, 0);
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid rgb(0, 0, 0, 0);
  font-weight: 700;
  font-style: normal;
  color: #7f7f7f;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-color: rgb(204, 204, 204);
  background-color: rgb(246, 246, 246);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid rgb(204, 204, 204);
  margin: 0;
}

>>> .el-tabs__nav {
  left: 60px;
}
.foot-container {
  margin-top: 3%;
  margin-left: 38%;
  width: 20%;
  text-align: center;
}
//邮箱手机号按钮
.plusAndMinus {
  text-align: left;
}
// 入力框
.inputWidth {
  display: block;
  width: 75% !important;
}
.inputWidth2 {
  display: block;
  width: 84%;
}
// 姓名入力框
.inputWidth3 {
  display: block;
  width: 82%;
}
.textAreaCss {
  margin-top: 9px;
}
>>> .el-col-3 {
  height: 40px;
}
>>> .el-input.is-disabled .el-input__inner {
  color: black;
}
.quarter-div {
  width: 50%;
  height: 50%;
  float: left;
}
>>> .el-input__inner {
  color: black;
}
>>> .el-textarea__inner {
  color: black;
}
// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}
.mar {
  margin: 15px;
}
.borderColor {
  border: 1px solid #cccccc;
}
>>> .el-date-editor.el-input,
>>> .el-date-editor.el-input__inner {
  width: 100%;
}
.foot-container2 {
  margin-top: 3%;
  margin-left: 40%;
  width: 20%;
  text-align: center;
}
>>> .el-textarea.is-disabled .el-textarea__inner {
  color: black;
}

>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
.selectOpr >>> .el-input__inner {
  height: 32px;
}
/* 地域列表高度 */
>>> .localeSelect .el-scrollbar {
  max-height: 8rem;
}
>>> .el-tag.el-tag--info{
  height: 20px;
}
>>>.el-input--small .el-input__inner{
  height: 25px;
}
// 多选框溢出一行
>>> .el-select__tags {

flex-wrap: nowrap;
overflow: hidden;
}
.widthInput {
  width: 40%;
  margin-left: 10%;
}
.widthInputRight {
  width: 40%;
  // margin-right: 12.5%;
}
@media screen and (max-width: 1366px) {
  .widthInput {
    width: 50%;
    margin-left: 0;
  }
  .widthInputRight {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0213.vue